import { createFileRoute } from "@tanstack/react-router"
import { PolicyList } from "@/components/rema/policies"

function PoliciesPage() {
  return (
    <div className="p-6">
      <PolicyList />
    </div>
  )
}

export const Route = createFileRoute("/rema/policies/")({
  staticData: {
    title: 'Manage Policies',
    isSecured: true,
  },
  component: PoliciesPage,
})
